import { makeAutoObservable } from 'mobx';

export default class UtilityStore {
  state = '';

  constructor() {
    makeAutoObservable(this);
  }

  setState = (state: string) => {
    this.state = state;
  };
}
